export const LOGIN_ROUTE = '*';
export const REGISTRATION_ROUTE = 'registration';
export const PROFILE_ROUTE = 'profile';
export const CARDS_ROUTE = 'cards';
export const CARD_ROUTE = 'cards/card/:cardsPackId'